import { render } from "./DetailsReport.vue?vue&type=template&id=1f6228ca&lang=pug"
import script from "./DetailsReport.vue?vue&type=script&setup=true&lang=js"
export * from "./DetailsReport.vue?vue&type=script&setup=true&lang=js"

import "./DetailsReport.vue?vue&type=style&index=0&id=1f6228ca&lang=sass"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__